// "Campaign" column cell: icon bubble + name + channel chips / offer subtitle.
// Used by the ListTable tableInfo in CampaignsList.

import React from 'react';
import styled from 'styled-components';
import { Icon, Typo } from '../../../../ui';
import { CHANNEL, OFFER } from '../../constants';
import ChannelChips from './ChannelChips';

const Cell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const IconBubble = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
`;

const NameBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Name = styled(Typo.TextTitle)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Icon shape differentiates campaign types; the bubble itself stays neutral
// so the list doesn't read as a rainbow.
const iconForCampaign = (campaign, theme) => {
  const c = theme.colors;
  const channels = campaign?.channels ?? [];
  const offer = campaign?.offer;
  let icon = <Icon.Email size='small' />;
  if (offer === OFFER.INVITATION) icon = <Icon.Gift size='small' />;
  else if (offer === OFFER.DISCOUNT) icon = <Icon.Coupon size='small' />;
  else if (channels.includes(CHANNEL.NETWORK_UPSELL)) icon = <Icon.TrendingUp size='small' />;
  return { icon, bg: c.NEU_100, fg: c.NEU_600 };
};

const CampaignNameCell = ({ campaign, theme }) => {
  const iconSpec = iconForCampaign(campaign, theme);
  return (
    <Cell>
      <IconBubble $bg={iconSpec.bg} $fg={iconSpec.fg}>{iconSpec.icon}</IconBubble>
      <NameBlock>
        <Name>{campaign.name}</Name>
        <ChannelChips campaign={campaign} theme={theme} />
      </NameBlock>
    </Cell>
  );
};

export default CampaignNameCell;
